import React from "react";

export const BOOK_URL = "https://www.penguin.co.uk/books/304527/alchemy-by-sutherland-rory/9780753556528";
export const TED_URL = "https://www.ted.com/speakers/rory_sutherland";

// Where the quotes came from: the book and the talks.
const Sources = ({ title = "Liked the quote? Go to the source." }: { title?: string }) => (
  <section className="rq-sources" aria-labelledby="rq-sources-title">
    <div className="rq-wrap">
      <h2 className="rq-h2" id="rq-sources-title">
        {title}
      </h2>
      <div className="rq-sources__pair">
        <a href={BOOK_URL} rel="noopener noreferrer" target="_blank" className="rq-offset rq-source">
          <img src="/rory-quotes/alchemy-book.png" alt="Cover of Alchemy by Rory Sutherland" width="140" height="140" loading="lazy" />
          <div>
            <span className="rq-eyebrow">The book</span>
            <h3>Alchemy</h3>
            <p className="rq-source__sub">The Surprising Power of Ideas That Don’t Make Sense</p>
            <p>Rory’s manifesto on why the logical answer is rarely the interesting one, and where most of these quotes live.</p>
            <span className="rq-link">Find the book →</span>
          </div>
        </a>
        <a href={TED_URL} rel="noopener noreferrer" target="_blank" className="rq-offset rq-source">
          <img src="/rory-quotes/rory-ted.png" alt="Rory Sutherland giving a TED talk" width="140" height="140" loading="lazy" />
          <div>
            <span className="rq-eyebrow">The talks</span>
            <h3>His TED Talks</h3>
            <p className="rq-source__sub">Watched many millions of times</p>
            <p>The fastest way to fall down the Rory rabbit hole. Funny, contrarian, and packed with the ideas behind half these quotes.</p>
            <span className="rq-link">Watch on TED →</span>
          </div>
        </a>
      </div>
    </div>
  </section>
);

export default Sources;
